import * as Cookies from 'es-cookie';

/**
 * langSelectorInit
 * @description A simple language selector navigation tool
 */
const langSelectorInit = () => {

    const langSelector = document.getElementById('language-selector');

    // Bind Select Menu
    if (langSelector) {
        langSelector.addEventListener('change', function () {
            const path = langSelector.value || '';

            if (path) {
                Cookies.set('preferredLangMlp', path.split('/')[1], { expires: 365 });
                // Redirect to the lang url page
                window.location.replace(path);
            }
        });
    }

    // Set localStorage to render client side preferred lang for commerce
    const languageAppCodeMeta = document.getElementsByName('languageAppCode')[0];

    if (languageAppCodeMeta) {
        const lang = languageAppCodeMeta.getAttribute('content');

        localStorage.setItem('languagePreference', lang);
    }
};

export {
    langSelectorInit
};
